<!-- *NAVBAR* starts -->
<app-navbar></app-navbar>
<!-- *NAVBAR* ends -->

<div class="wrapper" [ngClass]="{'show-overlay': !isNavbarSeachTextEmpty}" (click)="onWrapperClick();" (window:resize)="onResize($event)">

  <!-- *TOP* Menu starts -->
  <!-- *TOP* Menu ends -->

  <!-- *SIDE* Menu starts -->
  <!-- *SIDE* Menu ends -->

  <div class="main-panel">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
  </div>

  <!-- *NOTIFICATION-SIDEBAR* starts -->
<!--  <app-notification-sidebar></app-notification-sidebar>-->
  <!-- *NOTIFICATION-SIDEBAR* ends -->

  <!-- *CUSTOMIZER* starts -- Uncomment below code if you want to use customizer in your project -->
  <!-- <app-customizer></app-customizer> -->
  <!-- *CUSTOMIZER* ends -->
</div>
